import React, { useState, useEffect, useContext } from "react";
import styled from "styled-components";
import { Table, useTheme } from "@material-ui/core";
import moment from "moment";
import { ReactVirtualizedTable } from "../ui/Table/Virtualized/VirtualizedTable";
import { OrderContext } from "../../contexts/OrderContext";
import { PatronContext } from "../../contexts/PatronContext";
import NoPatron from "../layout/Pane/NoPatron";
import EnhancedTable from "../ui/Table/Enhanced/EnhancedTable";

const orderColumns = [
  {
    width: 75,
    label: "Status",
    dataKey: "status",
    numeric: false,
  },
  {
    width: 180,
    label: "Order Date",
    dataKey: "dateCreated",
    numeric: false,
  },
  {
    width: 250,
    label: "Ordered By",
    dataKey: "userEmail",
    numeric: false,
  },
  {
    width: 180,
    label: "Printed Date",
    dataKey: "dateImported",
    numeric: false,
  },
  {
    width: 100,
    label: "Portal Type",
    dataKey: "Portaltype",
    numeric: false,
  },
];

export const PreviousOrders = () => {
  const [orderHistory, setOrderHistory] = useState([]);
  const { patron } = useContext(PatronContext);
  const { getAllPatronOrders } = useContext(OrderContext);
  const { palette } = useTheme();

  const createHistory = (orders) => {
    let filteredOrders = [];
    var Pending = "pending";
    var Printed = "printed";

    orders.forEach(({ dateCreated, dateImported, userEmail, Portaltype }) => {
      filteredOrders.push({
        status: dateImported == null ? Pending : Printed,
        dateCreated: moment(dateCreated).calendar(),
        dateCreated: moment(dateCreated)
          .subtract(8, "hours")
          .format("DD/MM/YYYY, h:mm a"),
        // new Date(dateCreated).toLocaleDateString('en-AU', {
        //   day: '2-digit',
        //   month: '2-digit',
        //   year: 'numeric',
        //   hour: '2-digit',
        //   minute: '2-digit',
        //   second: '2-digit',
        // }),

        userEmail: userEmail,
        dateImported: dateImported
          ? moment(dateImported)
              .subtract(8, "hours")
              .format("DD/MM/YYYY, h:mm:ss a")
          : // new Date(dateImported).toLocaleDateTimeString({
            //   day: '2-digit',
            //   month: '2-digit',
            //   year: 'numeric',
            //   hour: '2-digit',
            //   minute: '2-digit',
            //   second: '2-digit',
            // })
            "N/A",
        Portaltype: Portaltype,
      });
    });
    setOrderHistory(filteredOrders);
    orderHistory.push(filteredOrders[0]);
  };

  useEffect(() => {
    getAllPatronOrders(patron.externalID).then((orders) => {
      createHistory(orders);
    });

    return () => {
      setOrderHistory([]);
    };
  }, [getAllPatronOrders, patron.externalID]);

  return orderHistory.length > 0 ? (
    <Container colour={palette.success.main}>
      <ReactVirtualizedTable data={orderHistory} columns={orderColumns} />
    </Container>
  ) : (
    <NoPatron message="No order history" />
  );
};

const Container = styled.div`
  padding: 3rem 2rem 2rem;
  color: ${(props) => props.colour};
`;
